module.exports = __webpack_public_path__ + "img/key-round.03455c03.png";